import { render, staticRenderFns } from "./CompareDataCollectionDialog.vue?vue&type=template&id=41e193a2&scoped=true&"
import script from "./CompareDataCollectionDialog.vue?vue&type=script&lang=js&"
export * from "./CompareDataCollectionDialog.vue?vue&type=script&lang=js&"
import style0 from "./CompareDataCollectionDialog.vue?vue&type=style&index=0&id=41e193a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e193a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VDialog,
  VForm,
  VIcon,
})
